import { createRouter, createWebHistory } from 'vue-router';

import DefaultLayout from '@/layouts/DefaultLayout.vue';

import HelloWorld from '../components/HelloWorld.vue';
import AboutPage from '@/components/AboutPage.vue';
import ContactPage from '@/components/ContactPage.vue';
import ServicePage from '@/components/ServicePage.vue';
import NewsPage from '@/components/NewsPage.vue';
import ExperiencePage from '@/components/ExperiencePage.vue';
import NewsDetailPage from '@/components/NewsDetailPage.vue';
import ExperienceDetailPage from '@/components/ExperienceDetailPage.vue';
import AdminLoginPage from '@/components/AdminLoginPage.vue';
import AdminDashboardPage from '@/components/Admin/AdminDashboardPage.vue';
import AdminUserListPage from '@/components/Admin/AdminUserListPage.vue';
import AdminNewsListPage from '@/components/Admin/AdminNewsListPage.vue';
import AdminExpListPage from '@/components/Admin/AdminExpListPage.vue';
import NotFound from '@/components/NotFoundPage.vue';

import store from '@/store';


const routes = [    
    {
      path: '/',
      component: DefaultLayout,
      children: [
        {
          path: '/',
          name: 'Home',
          component: HelloWorld,
        },
        {
          path: '/about',
          name: 'About',
          component: AboutPage,
        },                
        {
          path: '/contact',
          name: 'Contact',
          component: ContactPage,
        },   
        {
          path: '/service',
          name: 'Service',
          component: ServicePage,
        },
        {
          path: '/news',
          name: 'News',
          component: NewsPage,
        },
        {
          path: '/newsDetail/:newsId',
          name: 'NewsDetail',
          component: NewsDetailPage,
        },
        {
          path: '/experience',
          name: 'Experience',
          component: ExperiencePage,
        },
        {
          path: '/experienceDetail/:projectId/:isLogin',
          name: 'ExperienceDetail',
          component: ExperienceDetailPage,
        },
        { path: '/:pathMatch(.*)*', 
          name: 'NotFound', 
          component: NotFound },
      ],
    },            
    {
      path: '/admin',      
      component: DefaultLayout,
      children: [
        {
          path: '/admin',
          name: 'AdminLogin',
          component: AdminLoginPage,
        },        
        {
          path: '/adminDashboard',
          name: 'AdminDashboard',
          component: AdminDashboardPage,
          meta  : { requiresAuth: true }
        },
        {
          path: '/adminUserList',
          name: 'AdminUserList',
          component: AdminUserListPage,
          meta  : { requiresAuth: true }
        },
        {
          path: '/adminNewsList',
          name: 'AdminNewsList',
          component: AdminNewsListPage,
          meta  : { requiresAuth: true }
        },
        {
          path: '/adminExpList',
          name: 'AdminExpList',
          component: AdminExpListPage,
          meta  : { requiresAuth: true }
        },
      ],
    },    
];


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if(savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// global navigation guard for admin routes
router.beforeEach((to, from, next) => {
  // check if route requires authentication (mark admin routes with meta.requiresAuth)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('authToken');
    const user = store.state.user;
    
    if (!token || !user) {
      // redirect to login
      next({ name: 'AdminLogin', query: { redirect: to.fullPath } });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
